// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "markdown" + "-" + "f5fe6f8b67c528c88747" + ".chunk.js";
};